import axios from "axios";
import baseUrl from "./server";
import { logout } from "../reducers/authSlice";

export const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    "Client-Base-URL": window.location.origin,
  },
});

/**
 * REQUEST INTERCEPTOR
 */
axiosInstance.interceptors.request.use(
  (config) => {

    let user = null;
    let companyKey = null;

    try {
      user = JSON.parse(localStorage.getItem("user"));
      companyKey = JSON.parse(localStorage.getItem("companykey"));
    } catch (e) {
      console.log("LocalStorage parse error");
    }

    if (
      user?.childCompanyIds?.length > 0 &&
      companyKey?.id
    ) {
      config.params = {
        ...(config.params || {}),
        cmpId: companyKey.id,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * RESPONSE INTERCEPTOR
 */
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response?.status === 401) {


      window.location.href = "/login";

      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

/**
 * DEFAULT HEADERS
 */
const token = localStorage.getItem("token");

if (token) {
  axiosInstance.defaults.headers.common[
    "authorization"
  ] = token;
}

const sessionID = localStorage.getItem("sessionID");

if (sessionID) {
  axiosInstance.defaults.headers.common[
    "sessionID"
  ] = sessionID;
}

export default axiosInstance;